var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"posts"},[_c('content-container',{attrs:{"not-found":_vm.notFound}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }